import React from 'react';
import * as S from '../widgets.styles';

/**
 * "NEW" badge icon for insights
 */
const NewInsightLabel: React.FC = () => {
  return <S.HeaderSuffixBadge>NEW</S.HeaderSuffixBadge>;
};

NewInsightLabel.displayName = 'NewInsightLabel';

export default NewInsightLabel;
